import videojs from 'videojs-mux-kit';
import { formatDuration } from 'video-data-lib/utils/time';
import { setStyles } from 'video-embed/utils/dom';
const VideoJSComponent = videojs.getComponent('Component');
class ProgressDuration extends VideoJSComponent {
  constructor(player, options) {
    super(player, options);
    this.render = () => {
      const duration = this.player().duration();
      const currentTime = this.player().currentTime();
      if (duration && currentTime) {
        this.el().innerHTML = `${formatDuration(currentTime * 1000)} / ${formatDuration(duration * 1000)}`;
      }
    };
    this.el().className = this.buildCSSClass();
    setStyles(this.el(), {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'flex-start',
      userSelect: 'none'
    });
    player.ready(() => {
      player.on('timeupdate', this.render);
    });
  }
  buildCSSClass() {
    return `hs-progress-duration vjs-control vjs-time-control ${super.buildCSSClass()}`;
  }
}
VideoJSComponent.registerComponent('ProgressDuration', ProgressDuration);